/**
 * Visit reason codes for appointments.
 * Pregnancy-related codes (antenatal, postnatal) trigger linkage to pregnancy records.
 */

export type VisitReasonCode =
  | 'antenatal'
  | 'postnatal'
  | 'general'
  | 'follow-up'
  | 'procedure'
  | 'other'

export const VISIT_REASON_CODES: VisitReasonCode[] = [
  'antenatal',
  'postnatal',
  'general',
  'follow-up',
  'procedure',
  'other',
]

export const VISIT_REASON_LABELS: Record<VisitReasonCode, string> = {
  antenatal: 'Antenatal',
  postnatal: 'Postnatal',
  general: 'General',
  'follow-up': 'Follow-up',
  procedure: 'Procedure',
  other: 'Other',
}

export const PREGNANCY_RELATED_REASON_CODES: VisitReasonCode[] = ['antenatal', 'postnatal']

export function isPregnancyRelatedReason(code: VisitReasonCode | undefined): boolean {
  return code != null && PREGNANCY_RELATED_REASON_CODES.includes(code)
}

export function getVisitReasonLabel(code: VisitReasonCode | undefined): string {
  if (!code) return ''
  return VISIT_REASON_LABELS[code] ?? code
}

/** Completed pregnancies within 6 months (for postnatal visit linkage) */
export const POSTNATAL_LOOKBACK_MONTHS = 6

export function isOutcomeWithinMonths(outcomeDate: string | undefined, months: number): boolean {
  if (!outcomeDate) return false
  const outcome = new Date(outcomeDate)
  const cutoff = new Date()
  cutoff.setMonth(cutoff.getMonth() - months)
  return outcome >= cutoff
}
